"use strict";
import m from 'mithril';

import 'scss/login';

export default {
    view: ({attrs}) =>
        m(
            'section',
            {
                class: 'login'
            },
            [
                m('h4', {}, 'Login'),
                'post_message' in attrs ?
                    m(
                        'span',
                        {class: "post-message"},
                        'Invalid username or password.'
                    ) :
                    null,
                m('div', {class: 'clear'}),
                m(
                    'form',
                    {method: 'POST'},
                    [
                        m(
                            'div',
                            {class: 'row'},
                            [
                                m(
                                    'label',
                                    {
                                        for: 'username'
                                    },
                                    'Username'
                                ),
                                m(
                                    'input',
                                    {
                                        autocomplete: 'username',
                                        oninput: e => attrs.username = e.target.value,
                                        name: 'username',
                                        type: 'text',
                                        value: attrs.username
                                    }
                                )
                            ]
                        ),
                        m(
                            'div',
                            {class: 'row'},
                            [
                                m(
                                    'label',
                                    {
                                        for: 'password'
                                    },
                                    'Password'
                                ),
                                m(
                                    'input',
                                    {
                                        autocomplete: 'current-password',
                                        oninput: e => attrs.password = e.target.value,
                                        name: 'password',
                                        type: 'password',
                                        value: attrs.password
                                    }
                                )
                            ]
                        ),
                        m(
                            'div',
                            {class: 'row'},
                            [

                                m('span', {class: "label-placeholder"}),
                                m(
                                    'div',
                                    {class: 'input-container'},
                                    [
                                        m(
                                            'button',
                                            {
                                                onclick: attrs.submit
                                            },
                                            'Login'
                                        )
                                    ]
                                )
                            ]
                        )
                    ]
                ),
                m(
                    'p',
                    {class: 'request-credentials'},
                    [
                        m('a', {href: '/login/request'}, 'Request a login.'),
                        m(
                            'a',
                            {
                                href: `${
                                    attrs.production ?
                                        'https://auth.northpointfleetmanagement.com.au' :
                                        'http://auth.n.l'
                                }/login/forgot/${attrs.siteName}`
                            },
                            'Forgot your password?'
                        )
                    ]
                ),
                m('div.clear')
            ]
        )
};